<template>

  <div class="rounded-lg bg-white overflow-hidden shadow p p-6">
    <div class="relative max-w-lg mx-auto divide-y divide-gray-200">

<!--      <div>
        <h2 class="text-xl tracking-tight font-extrabold text-gray-900">Новости</h2>
        <p class="text-base mt-2 text-gray-500">Последние объявления, новости и анонсы сайта</p>
      </div>-->

      <div >
        <div class="pb-4 " v-for="post in announcements" :key="post.title">
          <p class="text-sm text-gray-500">
            <time :datetime="post.datetime">{{ post.date }}</time>
          </p>
          <a href="#" class="mt-2 block">
            <p class="text-base font-semibold text-gray-900">
              {{ post.title }}
            </p>
            <p class="mt-3 text-sm text-gray-500">
              {{ post.preview }}
            </p>
          </a>
          <div class="mt-3 ">
            <a :href="post.href" class="text-xs font-semibold text-primary-600 hover:text-primary-500"> читать дальше</a>
          </div>
        </div>
      </div>
    </div>
    <div >
      <a href="#"
         class="w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
        Посмотреть все </a>
    </div>
  </div>
</template>

<script>
const announcements = [
  {
    id: 1,
    title: 'Поздравляем с окончанием учебного года!',
    href: '#',
    preview:
        'Вот ещё один учебный год пролетел, поздравляем всех ребят, педагогов и родителей с его завершением!',
    date: 'Май 21, 2022',
    datetime: '2020-03-16',
  },
  {
    id: 2,
    title: 'Подведены итоги Всероссийской викторины по литературному чтению «Любимые книги. В гостях у Эдуарда Успенского»!',
    href: '#',
    preview:
        'Дорогие ребята, мы совершили захватывающее путешествие в сказочный мир, созданный талантливым писателем Эдуардом Успенским, ведь его произведения уникальны, интересны и познавательны. Они учат дружить и сопереживать, помогать друзьям, быть добрым и отзывчивым.',
    date: 'Май 19, 2022',
    datetime: '2020-03-16',
  },
  {
    id: 3,
    title: 'Подведены итоги VI Всероссийской викторины «ВЕЛИКАЯ ПОБЕДА»!',
    href: '#',
    preview:
        'В истории каждого народа есть события, которые оставляют неизгладимый след в его памяти, глубокой болью они отзываются в миллионах человеческих сердец. Для нашей страны это была Великая Отечественная война. Мы рассказали вам о Дне Победы – великом и очень важном для нашей страны празднике – о городах-героях, боевой технике и подвигах людей, живших в то время. Многие ребята правильно ответили на все вопросы викторины. Молодцы, ребята!',
    date: 'Май 5, 2022',
    datetime: '2020-03-16',
  },
]

export default {
  name: "AnnouncementCol",
  setup() {
    return {
      announcements,
          }
  },
}
</script>

<style scoped>

</style>